import { Tiles, LinkTiles, GettingStartedTile } from "../tile/tile";

export function getThemedTiles(theme, tiles, onClick) {
    if (theme === "web") {
        return (
            <Tiles
                Theme={theme}
                ColumnGap={8}
                RowGap={8}
                ColumnNumber={3}
                Tiles={tiles}
                Tile={(tile) => <GettingStartedTile Tile={tile} Dark OnClick={() => onClick(tile)} />} />
        );
    }

    return (
        <LinkTiles
            Theme={theme}
            Tiles={tiles}
            OnClick={(tile) => onClick(tile)} />
    );
}